import React from 'react';
import { Box, IconButton, styled } from '@mui/material';
import { ChevronLeft as ChevronLeftIcon, ChevronRight as ChevronRightIcon } from '@mui/icons-material';

const ScrollableFiltersContainer = styled(Box)(({ theme }) => ({
  overflow: 'hidden',
  position: 'relative',
  width: '100%',
  '&::before, &::after': {
    content: '""',
    position: 'absolute',
    top: 0,
    bottom: 0,
    width: 20,
    zIndex: 2,
    pointerEvents: 'none',
    transition: 'opacity 0.3s ease',
  },
  '&::before': {
    left: 0,
    background: 'linear-gradient(to right, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%)',
  },
  '&::after': {
    right: 0,
    background: 'linear-gradient(to left, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%)',
  },
  '&.show-left-fade::before': {
    opacity: 1,
  },
  '&.show-right-fade::after': {
    opacity: 1,
  },
  '&:not(.show-left-fade)::before': {
    opacity: 0,
  },
  '&:not(.show-right-fade)::after': {
    opacity: 0,
  },
}));

const ScrollableFiltersContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1.5),
  overflowX: 'auto',
  scrollBehavior: 'smooth',
  paddingBottom: theme.spacing(0.5),
  paddingTop: theme.spacing(0.5),
  paddingLeft: 0,
  paddingRight: theme.spacing(1),
  marginLeft: 0,
  marginRight: theme.spacing(1),
  scrollbarWidth: 'none',
  '-ms-overflow-style': 'none',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  '& > *': {
    flexShrink: 0,
  },
}));

const ScrollButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  zIndex: 3,
  backgroundColor: 'rgba(255, 255, 255, 0.95)',
  backdropFilter: 'blur(4px)',
  border: `1px solid ${theme.palette.divider}`,
  width: 32,
  height: 32,
  boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 1)',
    transform: 'translateY(-50%) scale(1.05)',
  },
  '&.left': {
    left: 8,
  },
  '&.right': {
    right: 8,
  },
}));

const ScrollableFilters = ({
  children,
  scrollRef,
  showLeftScroll,
  showRightScroll,
  onScrollLeft,
  onScrollRight,
  sx = {}
}) => {
  return (
    <ScrollableFiltersContainer
      className={`${showLeftScroll ? 'show-left-fade' : ''} ${showRightScroll ? 'show-right-fade' : ''}`}
      sx={sx}
    >
      {showLeftScroll && (
        <ScrollButton className="left" onClick={onScrollLeft}>
          <ChevronLeftIcon fontSize="small" />
        </ScrollButton>
      )}
      {showRightScroll && (
        <ScrollButton className="right" onClick={onScrollRight}>
          <ChevronRightIcon fontSize="small" />
        </ScrollButton>
      )}
      <ScrollableFiltersContent ref={scrollRef}>
        {children}
      </ScrollableFiltersContent>
    </ScrollableFiltersContainer>
  );
};

export default ScrollableFilters;